import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconPlusFrame16(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={16}
            height={16}
            className={customClassName}
            name="IconPlusFrame16"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M13 3H3a1 1 0 0 0-1 1v1h12V4a1 1 0 0 0-1-1m1 3H2v6a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1zM3 2a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zm5.464 5.5a.5.5 0 0 0-1 0v1.464H6a.5.5 0 0 0 0 1h1.464V11.5a.5.5 0 0 0 1 0V9.964H10a.5.5 0 0 0 0-1H8.464z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconPlusFrame16);
